$w.onReady(function () {

    init();

});

function init() {

    $w("#headlineText0").onClick((event) => {
        onClickHeadline(0);
    });

    $w("#headlineText1").onClick((event) => {
        onClickHeadline(1);
    });

    $w("#headlineText2").onClick((event) => {
        onClickHeadline(2);
    });

    $w("#headlineText3").onClick((event) => {
        onClickHeadline(3);
    });

    $w("#headlineText4").onClick((event) => {
        onClickHeadline(4);
    });

    $w("#headlineText5").onClick((event) => {
        onClickHeadline(5);
    });

    $w("#vectorPlus0").onClick((event) => {
        expaned_section(0);
    });

    $w("#vectorUp0").onClick((event) => {
        collapse_section(0);
    });

    $w("#vectorPlus1").onClick((event) => {
        expaned_section(1);
    });

    $w("#vectorUp1").onClick((event) => {
        collapse_section(1);
    });

    $w("#vectorPlus2").onClick((event) => {
        expaned_section(2);
    });

    $w("#vectorUp2").onClick((event) => {
        collapse_section(2);
    });

    $w("#vectorPlus3").onClick((event) => {
        expaned_section(3);
    });

    $w("#vectorUp3").onClick((event) => {
        collapse_section(3);
    });

    $w("#vectorPlus4").onClick((event) => {
        expaned_section(4);
    });

    $w("#vectorUp4").onClick((event) => {
        collapse_section(4);
    });

    $w("#vectorPlus5").onClick((event) => {
        expaned_section(5);
    });

    $w("#vectorUp5").onClick((event) => {
        collapse_section(5);
    });
}

// when clicking the headling and not the vector art
function onClickHeadline(numOfHeadline) {
    if ($w(`#sectionInfo${numOfHeadline}`).collapsed) {
        expaned_section(numOfHeadline);
    } else {
        collapse_section(numOfHeadline);
    }
}

// get the section number
function expaned_section(number) {
    $w(`#sectionInfo${number}`).expand();
    $w(`#vectorPlus${number}`).hide();
    $w(`#vectorUp${number}`).show();
}

function collapse_section(number) {
    $w(`#sectionInfo${number}`).collapse();
    $w(`#vectorPlus${number}`).show();
    $w(`#vectorUp${number}`).hide();
}